module.exports = __webpack_public_path__ + "static/img/2.7909dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/2/2.png
// module id = 6bcz
// module chunks = 0